import { Product, SimproJobDetails, SitesApi } from '@/api';
import { Entity } from '@/models/entity';
import { ApiUtils } from '@/common/ApiUtils';

export class SimproJobService<T extends Entity> {
	constructor(private product: Product & { simproJobs?: SimproJobDetails[] }) {}

	public async loadSimproJobs(): Promise<SimproJobDetails[] | { errorMessage: string }> {
		if (!this.product?.siteId) return { errorMessage: '' };

		try {
			const { data } = await new SitesApi().getSiteById(this.product?.siteId, {
				params: {
					include: 'simprojobs',
				},
			});
			if (data != null && 'simprojobs' in data)
				return (<SimproJobDetails[]>(data['simprojobs'] ?? [])).filter(
					(job: SimproJobDetails) => job.productId === this.product.id,
				);
			else return [];
		} catch (e) {
			return ApiUtils.handleApiError(
				e,
				`Failed to load simpro jobs for product '${this.product.id}'`,
			);
		}
	}
}
